import { type IServerSideGetRowsRequest } from "@tokenterminal/ui/DataTable"
import { type MartFetcherOptions } from "types/ApiTypes"

// Possibly to be removed in the future once all datasets migrated under one rule as dynamic

const MAX_ROWS = 1000000

export const applyFetcherOptions = (
  body: IServerSideGetRowsRequest,
  opts: MartFetcherOptions
) => {
  const offset =
    typeof opts.offset === "number" && opts.offset > -1 ? opts.offset : 0

  if (typeof opts.limit === "number") {
    body.endRow = opts.limit === -1 ? MAX_ROWS : offset + opts.limit
  }
  if (offset) {
    body.startRow = offset
  }
  if (opts.rowGroupCols) {
    body.rowGroupCols = opts.rowGroupCols
  }
  if (opts.groupKeys) {
    body.groupKeys = opts.groupKeys
  }

  return body
}
